export default "__VITE_ASSET__Cqa3EMS9__"